import { AuthenticationService } from './../../shared/authentication.service';
import { Ticket, TicketNotes } from './../../shared/ticket';
import { DisputedetailsComponent } from './../disputedetails/disputedetails.component';
import { QATicketActivity } from '../../shared/qaTicket';
import { Logger } from './../../shared/logger.service';
import { ViewtickethistoryComponent } from './../viewtickethistory/viewtickethistory.component';
import { Component, OnInit } from '@angular/core';
import { TicketHistory } from './../../shared/ticket';
import { QAResponse, QATicket, Question, QATicketNotes } from '../../shared/qaTicket';
import { TicketService } from '../../shared/ticketService';
import { QuestionService } from '../../shared/questionService';
import { LocalStorage } from '../../shared/localstorage.service';
import { ActivatedRoute } from '@angular/router';
import { ViewticketnotesComponent } from '../viewticketnotes/viewticketnotes.component';
import { InfodialogComponent } from '../../dialogs/infodialog/infodialog.component';
import { MatDialog, MatMenuTrigger } from '@angular/material';
import { isNullOrUndefined } from "util";
import { VieworaddqualitynotesComponent } from '../vieworaddqualitynotes/vieworaddqualitynotes.component';
import { Router } from '@angular/router';
import { ViewChild } from '@angular/core';

@Component({
  selector: 'app-viewticket',
  templateUrl: './viewticket.component.html',
  styleUrls: ['./viewticket.component.scss']
})

export class ViewTicketComponent implements OnInit {

  public pageTitle = 'QA Ticket';
  // Only need one now
  loading = false;
  ticket: Ticket;
  qaTicket = new QATicket();
  ticketResponses = new Array<QAResponse>();
  ticketQuestions = new Array<Question>();
  excavator = new Array<QAResponse>();
  notification = new Array<QAResponse>();
  location = new Array<QAResponse>();
  remarks = new Array<QAResponse>();
  map = new Array<QAResponse>();
  end = new Array<QAResponse>();
  showTicketCodes = false;
  correctionType = "";
  correctedTicket = false;
  ticketNotes = new TicketNotes();
  ticketHistory: TicketHistory[];
  qualityNotes: QATicketNotes[];
  disputedetails: QATicketActivity[];
  IsEvaluate = false;
  IsDispute = false;
  href : string = "";
  gpsPoints = [];
  gpsMethod = {};
  positiveResponse;
  informationHeaderText: string;
  showGoogle:Boolean = false;

  @ViewChild("menuTrigger") trigger: MatMenuTrigger;

  constructor(private ticketService: TicketService,
    private questionService: QuestionService,
    private localStorage: LocalStorage,
    route: ActivatedRoute,
    public dialog: MatDialog,
    public logger: Logger,
    public router : Router,
    private authService: AuthenticationService) {
    this.qaTicket.GCTicketNumber = route.snapshot.params['number'];
  }
  ngOnInit() {
    this.loading = true;
    this.href = this.router.url;
    this.ticketService.getTicket(this.qaTicket.GCTicketNumber, this.localStorage.getItem('token'), this.localStorage.getItem('currentState')).then(ticket => {
      this.questionService.getQATicket(this.qaTicket.GCTicketNumber, this.localStorage.getItem('currentState')).then(data => {
        if (data.QATicket != null) {
          
          this.qaTicket = data.QATicket;
          this.ticketQuestions = data.TicketQuestions;
          if(this.href.toLowerCase().includes("evaluate")){
            this.IsEvaluate = true;
          }
          this.ticket.qaTicketId = this.qaTicket.ID;
          this.qaTicket.Response.forEach(response => {

            const question = this.ticketQuestions.find(x => x.ID === response.QuestionID);
            response.QuestionText = question.QuestionText;
            response.Section = question.Section;
            response.CanNA = question.CanNA;
            response.ValidResponse = question.ValidResponse;
            response.CriticalLevel = question.CriticalLevel;
          });
          this.excavator = this.qaTicket.Response.filter(x => x.Section === 0);
          this.notification = this.qaTicket.Response.filter(x => x.Section === 1);
          this.location = this.qaTicket.Response.filter(x => x.Section === 2);
          this.remarks = this.qaTicket.Response.filter(x => x.Section === 3);
          this.map = this.qaTicket.Response.filter(x => x.Section === 4);
          this.end = this.qaTicket.Response.filter(x => x.Section === 5);
          this.correctionType = this.qaTicket.GCTicketCorrection;
          if (this.qaTicket.GCTicketCorrection === "Recalled" || this.qaTicket.GCTicketCorrection === "Cancelled") {
            this.correctedTicket = true;
          }
        }
        this.loading = false;
      });
      this.ticket = ticket;
      this.gpsPoints = ticket.gps       ? JSON.parse(ticket.gps)       : [];
      this.gpsMethod = ticket.gpsMethod ? JSON.parse(ticket.gpsMethod) : {};
      if (ticket.positiveResponse) this.positiveResponse = JSON.parse(ticket.positiveResponse);

      if (ticket.informationHeader) {
        var IH = JSON.parse(ticket.informationHeader);
        var IHStrings = [];
        var lineStatusSentence;

        if (IH.lineCondition && IH.lineType) {
          var capitalizeFirstLetter = (text: string) => text.charAt(0).toUpperCase() + text.slice(1);

          lineStatusSentence = capitalizeFirstLetter(IH.lineCondition) + " " + capitalizeFirstLetter(IH.lineType) + " Line"

          if (IH.lineType == 'unknown' && !IH.lineDescription) {
            lineStatusSentence += " - Line described as " + IH.lineDescription;
          }
        }

        if (IH.previousTicketNumber) IHStrings.push(IH.previousTicketNumber);
        if (lineStatusSentence)      IHStrings.push(lineStatusSentence);
        if (IH.crewStatus)           IHStrings.push(IH.crewStatus);
        if (IH.customerStatus)       IHStrings.push(IH.customerStatus);
        if (IH.additionalDetails)    IHStrings.push(IH.additionalDetails);
        if (IH.markingsVisible)      IHStrings.push(IH.markingsVisible);
        if (IH.damagedBy)            IHStrings.push("Damaged by: " + IH.damagedBy);
        if (IH.damagedWith)          IHStrings.push("Damaged with: " + IH.damagedWith);

        this.informationHeaderText = IH.ticketType + "-" + IHStrings.join(', ')
      }
    });
  }
  ToggleTicketCodes() {
    if (this.showTicketCodes) {
      this.showTicketCodes = false;
    } else {
      this.showTicketCodes = true;
    }
  }

  getGeoCallTicketNotes() {
    this.questionService.getTicketNotes(this.localStorage.getItem("token"), this.ticket.ticketId, this.localStorage.getItem('currentState')).subscribe(res => {
      this.ticketNotes = res;
      if (!isNullOrUndefined(this.ticketNotes.itemNote)) {
        let ticketNotesDialog = this.dialog.open(ViewticketnotesComponent, {
          width: '500px',
          data: this.ticketNotes
        });
      } else {
        let infoDialog = this.dialog.open(InfodialogComponent, {
          width: '500px',
          data: {
            title: 'Ticket Notes',
            content: 'Ticket Notes not found.'
          }
        });
      }
    });

  }

  getGeoCallTicketHistory() {
    this.questionService.getTicketHistory(this.localStorage.getItem("token"),
      this.ticket.ticketId, this.ticket.number, this.ticket.takenBy,
      this.ticket.ticketType, this.ticket.creation, this.localStorage.getItem('currentState')).subscribe(res => {
        this.ticketHistory = res.reverse();
        let ticketHistoryDialog = this.dialog.open(ViewtickethistoryComponent, {
          width: '800px',
          data: this.ticketHistory
        });
        //this.screen = false;
      });
  }

  getQualityNotes() {
    this.questionService.getQualityNotes(this.qaTicket.ID, this.localStorage.getItem('currentState')).subscribe(res =>{
      let value = this.IsEvaluate;
      this.qualityNotes = res;
      let qualityNotesDialog = this.dialog.open(VieworaddqualitynotesComponent, {
        width: '600px',
        data: {
          notes: this.qualityNotes,
          isEvaluate: value
        }
      });
    });
  }

  getDisputeDetails(){
    this.questionService.getDisputeDetails(this.qaTicket.ID, this.localStorage.getItem('currentState')).subscribe(res =>{
      this.disputedetails = res;
      this.disputedetails.forEach(item =>{
        if(item.IsComplete){
          item.Status = 'Dispute Close';
          item.DateOn = item.Completion;
          item.UserBy = item.ActivityCompleteBy;
        }
        else{
          item.Status = 'Dispute Open';
          item.DateOn = item.Creation;
          item.UserBy = item.ActivityStartBy;
        }
      });
      let qualityNotesDialog = this.dialog.open(DisputedetailsComponent, {
        width: '600px',
        data: {
          disputes: this.disputedetails,
          QATicketId: this.qaTicket.ID
        }
      });
    });
  }
  backClick(){
    this.router.navigate(["viewmytickets"]);
  }

  ShowGoogle(){
    this.showGoogle = !this.showGoogle;
}
}
